import {useContext, useEffect, useState} from 'react';
import Steps from '../components/common/Steps';
import Form from '../components/common/Form';
import ErrorMessage from '../components/common/ErrorMessage';
import {useHistory} from 'react-router-dom';
import Spinner from '../components/common/Spinner';
import {AppContext} from "../context/AppContext";
import {getLocalItem, invalidQR} from "../libs/helpers";

const Step1 = ({location}) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [message, setMessage] = useState('');
    const [data, setData] = useState({});

    const history = useHistory();

    const {appData} = useContext(AppContext);

    const recaptchaKey = process.env.REACT_APP_RECAPTCHA_KEY;
    const onError = (message,) => {
        history.push('/error', {message});
    };
    const onSubmit = (loading = true) => {
        setLoading(loading);
    };

    useEffect(() => {
        if (!location.state || location.state?.hasError || location.state?.from !== 'SCAN') {
            history.push('/error', {message: location?.state?.message || invalidQR()});
        }
        let data = appData || getLocalItem('appData');
        if (data && data.sessionID) {
            setData(data);
        } else {
            setError(true);
            setMessage(invalidQR());
        }
        return () => {
            setData({});
        };
    }, [location, history]);

    return (
        <div className={`app-step step-1`}>
            {!error ? (
                <>
                    <div className="row justify-content-center">
                        {loading && <Spinner absolute={true}/>}
                        <div className="col-md-12 col-sm-12 col-lg-7 col-xl-6">
                            <div className="content-box container position-relative">
                                <div className="row justify-content-center mt-3">
                                    <Form
                                        title={data.title}
                                        data={data}
                                        onError={onError}
                                        onSubmit={onSubmit}
                                        recaptchaKey={recaptchaKey}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <ErrorMessage message={message}/>
            )}
        </div>
    );
};

export default Step1;
